import React from 'react';
// import { RouteComponentProps } from 'react-router-dom';
import { CUSTOMER_SUPPORT, ASSET_TEAM, VICE_PRESIDENT_FSE, VP_FIBER } from '../../../../utils/departments/helpers';
import CustomerSupportSideBarItem from '../../../layouts/customer-support/sidebar/CustomerSupportSideBarItem';
import { useUser } from '../../../../hooks/shared/user/useUser';
import AssetTeamNavBar from '../../../layouts/asset-team/AssetTeamNavBar';
import CustomerSupportNavBar from '../../../layouts/customer-support/CustomerSupportNavBar';
import RelocationBody from '../relocation/RelocationBody';
import useCheckTwoDepartments from '../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import useCheckFiveDepartments from '../../../../hooks/shared/custom/check-department/useCheckFiveDepartments';
const RelocationShared = ({ history }) => {
  useCheckFiveDepartments(`${CUSTOMER_SUPPORT}`, `${VICE_PRESIDENT_FSE}`, `${ASSET_TEAM}`, `${VP_FIBER}`, history);
  const {
    user: { role_id },
    profile: { firstName },
  } = useUser();

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        {sessionStorage.getItem('departmentId') === CUSTOMER_SUPPORT ? (
          <CustomerSupportNavBar currentPage="Relocation" roleID={role_id} position={firstName} />
        ) : (
          sessionStorage.getItem('departmentId') === ASSET_TEAM && (
            <AssetTeamNavBar currentPage="Relocation" position={firstName} />
          )
        )}
        <RelocationBody />
      </main>
    </div>
  );
};

export default RelocationShared;
